import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import T from 'i18n-react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as AccountStore from '../store/Account';
import * as CommonStore from '../store/Common';
import * as UserStore from '../store/User';
import LoadingButton from './shared/LoadingButton';
import LoadingOverlay from './shared/LoadingOverlay';
import MessageError from './shared/MessageError';


const Scroll = require('react-scroll');

class TwoFactorAuthentication extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: {
                'authentication-code': { isRequired: true, isValid: true, value: ['_', '_', '_', '_', '_', '_'] },
                'action-origin': 'field-update'
            }
        };
    }

    componentWillMount() {
        Scroll.animateScroll.scrollToTop({ smooth: true, duration: 500 });
        document.title = T.translate('common.client') + ' | ' + T.translate('twoFactorAuthentication.title');
    }

    onChange = (e) => {
        var targetId = e.target.id || '';
        var controlIdx = parseInt(targetId.replace('authentication-code', '')) - 1;
        if (isNaN(controlIdx) || controlIdx < 0 || controlIdx > 5) return;

        var rawVal = e.target.value || '';
        var digitsOnly = rawVal.replace(/\D/g, '');

        if (digitsOnly.length > 1) {
            this.handleMultiDigit(digitsOnly);
            return;
        }

        var newDigit = digitsOnly.length > 0 ? digitsOnly.slice(-1) : '_';

        var newCodeValues = [...this.state.fields['authentication-code'].value];
        newCodeValues[controlIdx] = newDigit;

        var newFields = {
            ...this.state.fields,
            'action-origin': 'field-update',
            'authentication-code': {
                ...this.state.fields['authentication-code'],
                value: newCodeValues
            }
        };

        this.setState({ fields: newFields });

        if (newDigit !== '_' && controlIdx < 5) {
            var nextElem = document.getElementById('authentication-code' + (controlIdx + 2));
            if (nextElem) {
                nextElem.focus();
                if (nextElem.select) nextElem.select();
            }
        }
    }

    onFocus = (e) => {
        if (e && e.target && e.target.select) {
            e.target.select();
        }
    }

    onPaste = (e) => {
        var clipboardData = e.clipboardData || (window.clipboardData ? window.clipboardData : null);
        if (!clipboardData) return;
        var pasteText = clipboardData.getData('text') || '';
        var digitsOnly = pasteText.replace(/\D/g, '');
        if (digitsOnly.length > 0) {
            e.preventDefault();
            this.handleMultiDigit(digitsOnly);
        }
    }

    handleMultiDigit = (digitsStr) => {
        var digits = digitsStr.split('').slice(0, 6);
        var newCodeValues = Array(6).fill('_').map((_, i) => digits[i] || '_');

        var newFields = {
            ...this.state.fields,
            'action-origin': 'field-update',
            'authentication-code': {
                ...this.state.fields['authentication-code'],
                value: newCodeValues
            }
        };

        this.setState({ fields: newFields });

        var focusIdx = Math.min(digits.length + 1, 6);
        var targetElem = document.getElementById('authentication-code' + focusIdx);
        if (targetElem) {
            targetElem.focus();
            if (targetElem.select) targetElem.select();
        }
    }

    onKeyDown = (e) => {
        if (e.key === 'Backspace') {
            var targetId = e.target.id || '';
            var controlIdx = parseInt(targetId.replace('authentication-code', '')) - 1;
            var currentVal = this.state.fields['authentication-code'].value[controlIdx];
            if ((currentVal === '_' || currentVal === '') && controlIdx > 0) {
                var prevElem = document.getElementById('authentication-code' + controlIdx);
                if (prevElem) {
                    prevElem.focus();
                    if (prevElem.select) prevElem.select();
                }
            }
        }
    }

    isFormValid = () => {
        var field = this.state.fields['authentication-code'];
        var value = field.value.join('');
        var isValid = !(field.isRequired && (value === '' || value.includes('_')));

        var newFields = {
            ...this.state.fields,
            'action-origin': 'form-validation',
            'authentication-code': {
                ...field,
                isValid: isValid
            }
        };

        this.setState({ fields: newFields });

        if (isValid) {
            this.props.setCommonError('');
        } else {
            this.props.setCommonError(T.translate('common.thereAreMissingFields'));
        }

        return isValid;
    }

    submitCode = () => {
        if (this.isFormValid()) {
            var value = this.state.fields['authentication-code'].value.join('');
            this.props.twoFactorAuthCode({ twoFactorAuthCode: value });
        }
    }

    generateNewAuthCode = (e) => {
        e.preventDefault();
        this.props.generateNewAuthCode();
    }

    getInputValue = (idx) => {
        var val = this.state.fields['authentication-code'].value[idx];
        return (val && val !== '_') ? val : '';
    }

    getInputStyle = (idx) => {
        let state = this.state;
        var field = state.fields['authentication-code'];
        var isInvalid = state.fields['action-origin'] === 'form-validation' && field.value[idx] === '_';
        return {
            border: isInvalid ? '1px solid #dc3545' : '1px solid #b0b5bc',
            boxShadow: isInvalid ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : 'none'
        };
    }

    setValidationStyle = (idx) => {
        let state = this.state;
        var field = state.fields['authentication-code'];
        if (state.fields['action-origin'] !== 'form-validation') {
            return '';
        }
        return field.value[idx] !== '_' ? '' : 'is-invalid';
    }

    getTranslatedError = (error) => {
        switch (error) {
            case 'twoFactorAuthentication.invalidCode':
            case 'twoFactorAuthentication.cantGenerateANewCode':                
                return T.translate(error, this.props.systemProperties);
            default:
                return error;
        }
    }

    render() {
        return (
            <div className="my-account-md-container">
                <div className="my-account-md-content">
                    <div className="page-header">
                        <div className="page-title">{T.translate('twoFactorAuthentication.pageTitle')}</div>
                    </div>
                    <div className="diverter" />

                    <LoadingOverlay loading={this.props.userLoading || this.props.accountLoading} />

                    {this.props.accountPersons && <React.Fragment>
                        <MessageError>{this.getTranslatedError(this.props.accountErrorMessage + this.props.userErrorMessage + this.props.commonErrorMessage)}</MessageError>

                        {this.props.twoFactorAuthentication.isResend && <div className="alert alert-success mb-5 mt-4 p-4 fade in alert-dismissible show d-flex">
                            <div className="d-flex">
                                <FontAwesomeIcon className="mr-3" size="2x" icon={faCheckCircle} />
                                <p>
                                    {T.translate('twoFactorAuthentication.resendConfirmation', this.props.systemProperties)}
                                </p>
                            </div>
                        </div>}

                        <p>{T.translate('twoFactorAuthentication.paragraph1')}</p>
                        <div className="form-group row mt-4">
                            {[0, 1, 2, 3, 4, 5].map((idx) => (
                                <div key={idx} className="col-2 px-1">
                                    <input
                                        type="text"
                                        maxLength={1}
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        autoComplete="one-time-code"
                                        id={`authentication-code${idx + 1}`}
                                        value={this.getInputValue(idx)}
                                        style={this.getInputStyle(idx)}
                                        className={"form-control single-value-input " + this.setValidationStyle(idx)}
                                        onChange={this.onChange}
                                        onFocus={this.onFocus}
                                        onPaste={this.onPaste}
                                        onKeyDown={this.onKeyDown}
                                    />
                                </div>
                            ))}
                            <div className="invalid-feedback">{T.translate('common.thisFieldIsRequired')}</div>
                        </div>
                        <div>
                            <LoadingButton className="btn btn-primary btn-lg" onClick={this.submitCode}>{T.translate('twoFactorAuthentication.submit')}</LoadingButton>
                            <a href="#" onClick={this.generateNewAuthCode} className="a-link ml-0 ml-sm-4 mt-3 mt-sm-0 d-block d-sm-inline-block">{T.translate('twoFactorAuthentication.didntReceivedCode')}</a>
                            {false && <NavLink to="/" className="a-link ml-0 ml-sm-4 mt-3 mt-sm-0 d-block d-sm-inline-block">{T.translate('twoFactorAuthentication.didntReceivedCode')}</NavLink>}
                        </div>

                        {false && <NavLink to="/" className="a-link ml-0 ml-sm-4 mt-3 mt-sm-0 d-block d-sm-inline-block">{T.translate('twoFactorAuthentication.backToLogin')}</NavLink>}
                    </React.Fragment>}

                    {!this.props.accountPersons && <React.Fragment>
                        <MessageError>{T.translate('common.accessDenied')}</MessageError>
                        <NavLink to="/" className="a-link ml-0 ml-sm-4 mt-3 mt-sm-0 d-block d-sm-inline-block">{T.translate('twoFactorAuthentication.backToLogin')}</NavLink>
                    </React.Fragment>}
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({ ...state.account, ...state.user, ...state.common }),
    dispatch => bindActionCreators({ ...AccountStore.actionCreators, ...UserStore.actionCreators, ...CommonStore.actionCreators }, dispatch)
)(TwoFactorAuthentication);
